import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export interface AnalyticsSummary {
  total_interactions: number;
  avg_response_time: number;
  total_cost: number;
  total_tokens: number;
  peak_hour: number;
  daily_stats: DailyStat[];
  hourly_distribution: Record<string, number>;
}

export interface DailyStat {
  date: string;
  total_interactions: number;
  total_cost: number;
  total_tokens: number;
  total_response_time: number;
  hourly_counts: Record<string, number>;
}

export interface Session {
  session_id: string;
  start_time: number;
  end_time: number;
  last_activity: number;
  message_count: number;
}

export interface Interaction {
  interaction_id: string;
  session_id: string;
  timestamp: number;
  user_query: string;
  bot_response: string;
  response_time: number;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  estimated_cost: number;
  response_length: number;
  query_length: number;
}

class AnalyticsService {
  async getDashboardData(days: number = 7): Promise<any> {
    const response = await axios.get(`${API_BASE_URL}/analytics/dashboard?days=${days}`);
    if (!response.data.success) {
      throw new Error(response.data.error);
    }
    return response.data.data;
  }

  async getRecentSessions(limit: number = 50): Promise<Session[]> {
    const response = await axios.get(`${API_BASE_URL}/analytics/sessions?limit=${limit}`);
    if (!response.data.success) {
      throw new Error(response.data.error);
    }
    return response.data.data;
  }

  async getSessionInteractions(sessionId: string): Promise<Interaction[]> {
    const response = await axios.get(`${API_BASE_URL}/analytics/interactions/${sessionId}`);
    if (!response.data.success) {
      throw new Error(response.data.error);
    }
    return response.data.data;
  }
}

export const analyticsService = new AnalyticsService();